import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const EmbeddedBoardFooterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmbeddedBoardFooter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"EmbeddedBoardFooter","document":EmbeddedBoardFooterDocument}} as const;
export type EmbeddedBoardFooterQueryVariables = Types.Exact<{
  boardId: Types.Scalars['ID']['input'];
}>;


export type EmbeddedBoardFooterQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id' | 'url'>
  )> }
);

/**
 * __useEmbeddedBoardFooterQuery__
 *
 * To run a query within a React component, call `useEmbeddedBoardFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbeddedBoardFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbeddedBoardFooterQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useEmbeddedBoardFooterQuery(
  baseOptions: TrelloQueryHookOptions<
    EmbeddedBoardFooterQuery,
    EmbeddedBoardFooterQueryVariables
  > &
    (
      | { variables: EmbeddedBoardFooterQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: EmbeddedBoardFooterDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    EmbeddedBoardFooterQuery,
    EmbeddedBoardFooterQueryVariables
  >(EmbeddedBoardFooterDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useEmbeddedBoardFooterLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    EmbeddedBoardFooterQuery,
    EmbeddedBoardFooterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EmbeddedBoardFooterQuery,
    EmbeddedBoardFooterQueryVariables
  >(EmbeddedBoardFooterDocument, options);
}
export function useEmbeddedBoardFooterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        EmbeddedBoardFooterQuery,
        EmbeddedBoardFooterQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EmbeddedBoardFooterQuery,
    EmbeddedBoardFooterQueryVariables
  >(EmbeddedBoardFooterDocument, options);
}
export type EmbeddedBoardFooterQueryHookResult = ReturnType<
  typeof useEmbeddedBoardFooterQuery
>;
export type EmbeddedBoardFooterLazyQueryHookResult = ReturnType<
  typeof useEmbeddedBoardFooterLazyQuery
>;
export type EmbeddedBoardFooterSuspenseQueryHookResult = ReturnType<
  typeof useEmbeddedBoardFooterSuspenseQuery
>;
export type EmbeddedBoardFooterQueryResult = Apollo.QueryResult<
  EmbeddedBoardFooterQuery,
  EmbeddedBoardFooterQueryVariables
>;
